import style from "./style.module.sass";
import Button from "@material-ui/core/Button";
import React, { useState }  from "react";
import {useTranslation} from "react-i18next";
import config from "../../../../config"
import { useTheme } from "@material-ui/core/styles"
export default function AnalyseButton({
                                          handleOnAnalyseClick,
                                          analyseButtonEnable,
                                          setAnalyseButtonEnable,
                                          tabIndex
                                      }) {
    const {t} = useTranslation();
    const {theme: { bgColors, colors }} = useTheme()
    const [isHovered, setIsHovered] = useState(false)
    return (
        <div className={`${style.selectCont}`} title={t('accessibility_analysis_start-analysis-button')}
         style={{ backgroundColor: bgColors.bgBoxes, }}
        >
            {/* eslint-disable-next-line jsx-a11y/no-access-key */}
            <Button onClick={() => {
                if (analyseButtonEnable) {
                    setAnalyseButtonEnable(false);
                    handleOnAnalyseClick()
                }
            }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    accessKey={config.accessKeys.runAnalyse}
                    tabIndex={tabIndex}
                    disabled={!analyseButtonEnable}
                    className={`${style.loader} ${analyseButtonEnable && style.active}`}
                    style={{backgroundColor: analyseButtonEnable ? isHovered ? bgColors.bgProgressHover : bgColors.bgAnalyseBtnActive : bgColors.bgBoxes}}>
                <div className={style.figure}>
                    <div className={`${style.circle} ${analyseButtonEnable && style.active}`} style={{backgroundColor: analyseButtonEnable ? bgColors.bgCircle : bgColors.bgAnalyseButton}}/>
                    <div className={style.top} style={{backgroundColor: analyseButtonEnable ? isHovered ? bgColors.bgProgressHover : bgColors.bgProgress100 : bgColors.bgAnalyseTop}} />
                    <div className={style.center} style={{backgroundColor: analyseButtonEnable ? isHovered ? bgColors.bgProgressHover : bgColors.bgProgress100 : bgColors.bgAnalyseCenter}}>
                        <div className={`${style.center_circle} ${analyseButtonEnable && style.active}`} style={{backgroundColor: analyseButtonEnable ? bgColors.bgCircle : bgColors.bgAnalyseCenterC}}/>
                    </div>
                </div>
                <h4 style={{color: analyseButtonEnable ? colors.colorWhite : colors.colorProgress100}}>{t("Start analysis")}</h4>
            </Button>
        </div>
    )
}